import { getTierThreshold } from 'loyalty/selectors/getLoyaltyTierThresholds'

export interface TierProgressionRetainModeState {
  isRetainMode: boolean
  isAtRiskOfDowngrade: boolean
}

/**
 * Default "retain current tier" vs "progress toward next tier" (no upgrade-view toggle).
 * Matches `useLoyaltyTierProgressionMode` when `showUpgradeView` is false.
 *
 * `nextTier` must use the same definition as the rest of the UI (e.g. `getLoyaltyNextTier` for the
 * display tier, or `determineNextLoyaltyTier` for a raw account tier when that tier is what you key off).
 */
export function getTierProgressionRetainModeState(
  tier: App.LoyaltyTier,
  nextTier: App.LoyaltyTier | undefined,
  account: App.LoyaltyAccount,
  tierThresholds: Record<App.LoyaltyTier, App.LoyaltyTierThreshold> | undefined,
): TierProgressionRetainModeState {
  const currentTierThreshold = tierThresholds ? getTierThreshold(tierThresholds, tier) : undefined
  const retentionCreditsThreshold = account.totalCreditsForTierRetention || currentTierThreshold?.statusCredits || 0
  const retentionNightsThreshold = account.numberOfNightsForTierRetention || currentTierThreshold?.nights || 0
  const isAtRiskOfDowngrade = tier !== 'bronze' && (
    account.statusCredits < retentionCreditsThreshold ||
    account.numberOfNights < retentionNightsThreshold
  )
  const isRetainMode = !nextTier || isAtRiskOfDowngrade
  return { isRetainMode, isAtRiskOfDowngrade }
}
